import { render, staticRenderFns } from "./CosteoProrrateado.vue?vue&type=template&id=5fd0ef93"
import script from "./CosteoProrrateado.vue?vue&type=script&lang=js"
export * from "./CosteoProrrateado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports